import { render } from "./password_reset.vue?vue&type=template&id=3a677309"
import script from "./password_reset.js?vue&type=script&lang=js&external"
export * from "./password_reset.js?vue&type=script&lang=js&external"

import "./password_reset.vue?vue&type=style&index=0&id=3a677309&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__